<template>
    <div class="grant">
        <div class="center">
            <div class="title">
                <img src="@/assets/pc/Fund/grant-head.png" class="Img"/>
                Transformers

            </div>
            <div class="question">
                Foundation grant
            </div>
            <div class="answer">
                This program is for entrepreneurs, developers, researchers, and advocates who want to contribute to the TFSC ecosystem. You may want to start your project on TFSC, add money to your DAO’s coffers, or conduct research on the social impact of decentralization. The TFSC Foundation welcomes all projects interested in building a more scalable, equitable, and creative future on TFSC.

            </div>
            <div class="answer">
                Please be sure to complete all sections of the application form. While you should provide precise details of the project timeline and scope, it is not necessarily advisable to respond to lengthy feedback! We read many of the submissions, so we would appreciate it if you could concisely convey your thoughts. All applications will be accepted and reviewed on a rolling basis. Each individual and team may submit only one application at a time.
            </div>
            <div class="answer">
                Individuals or teams can reapply for another grant upon completion of pre-specified milestones for the project. Grants are issued in TFSC tokens, but in exceptional cases, they can be issued in USD/euro, etc. The TFSC Foundation offers different funding approaches depending on your current stage. A guide can be found here  //TFSC Fund Allocation Plan //.
            </div>
            <div class="answer">
                You will receive a follow-up email confirming that your application has been received and received separately at the beginning of the review process. 
            </div>
            <div class="answer">
                If you have questions on transformerschain.com/grants did not get the answer, please send an email to 
                <span>grant@transformerschain.com</span> to contact us.
            </div>
            <div class="apply_to"  @click="goPage('/pc/Form1')">
                Fill out the form
            </div>

        </div>
    </div>
    
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                currentPath: "/pc/Grant", //当前路由地址
            };
        },
        methods: {
            goPage(url) {
                this.$router.push(url);
                this.currentPath = url;
                sessionStorage.setItem("currentPath", url);
            },
        }
    }
</script>

<style lang="less"  scoped>
    .grant{
        padding-top: 96px;
        padding-bottom: 120px;
        text-align: center;
        .center{
            margin: 0 auto;
            width: 1152px;
            height: 981px;
            background: #FFFFFF;
            border-radius: 16px 16px 16px 16px;
            text-align: left;
            opacity: 1;
            .title{
                padding: 100px 100px 60px 100px;
                font-size: 30px;
                font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
                font-weight: 900;
                color: #141414;
                line-height: 45px;
                margin-bottom: 40px;

            }
            .question{
                padding: 0 100px;
                margin-bottom: 20px;
                font-size: 28px;
                font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                font-weight: bold;
                color: #141414;
                line-height: 36px;
            }
            .answer{
                padding: 0 100px;
                margin-bottom: 20px;
                font-size: 18px;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #141414;
                line-height: 27px;
                span{
                    font-weight: bold;
                    text-decoration: underline #141414;
                }
            }
            .apply_to{
                margin: 60px auto 100px auto;
                text-align: center;
                width: 167px;
                height: 42px;
                background: #CF61DC;
                border-radius: 8px 8px 8px 8px;
                opacity: 1;

                font-size: 18px;
                font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 42px;
            }
        }
    }

</style>